import _extends from "@babel/runtime/helpers/extends";
/** @jsx jsx */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { FormattedMessage } from 'react-intl-next';
import { R300 } from '@atlaskit/theme/colors';
import LockIcon from '@atlaskit/icon/glyph/lock-filled';
import { Frame } from '../components/Frame';
import { Provider } from '../components/Provider';
import { Byline } from '../../common/Byline';
import { ActionList } from '../components/ActionList';
import { Content } from '../components/Content';
import { messages } from '../../../messages';
import { ContentFooter } from '../components/ContentFooter';
import { ContentHeader } from '../components/ContentHeader';
import { handleClickCommon } from '../utils/handlers';
import { Link } from '../components/Link';
import { UnresolvedText } from '../components/UnresolvedText';
/**
 * Class name for selecting non-flexible forbidden block card
 *
 * @deprecated {@link https://hello.jira.atlassian.cloud/browse/ENGHEALTH-6878 Internal documentation for deprecation (no external access)}
 * Using this selctor is deprecated as once the flexible block card feature flag is removed, this class will no longer be used.
 */
export const blockCardForbiddenViewClassName = 'block-card-forbidden-view';

/**
 * Class name for selecting link inside non-flexible forbidden block card
 *
 * @deprecated {@link https://hello.jira.atlassian.cloud/browse/ENGHEALTH-6878 Internal documentation for deprecation (no external access)}
 * Using this selctor is deprecated as once the flexible block card feature flag is removed, this class will no longer be used.
 */
export const blockCardForbiddenViewLinkClassName = 'block-card-forbidden-view-link';
export const ForbiddenView = ({
  context = {
    text: ''
  },
  isSelected = false,
  actions = [],
  testId = 'block-card-forbidden-view',
  link = '',
  onClick = () => {},
  requestAccessContext = {},
  actionOptions
}) => {
  const handleClick = event => handleClickCommon(event, onClick);
  const {
    action,
    descriptiveMessageKey = 'invalid_permissions_description',
    hostname = '',
    buttonDisabled
  } = requestAccessContext;
  const items = action !== undefined && !(buttonDisabled !== null && buttonDisabled !== void 0 ? buttonDisabled : false) ? [...actions, action] : actions;
  return jsx(Frame, {
    isSelected: isSelected,
    testId: testId
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ,
    className: blockCardForbiddenViewClassName,
    isFluidHeight: true
  }, jsx(Content, {
    isCompact: true
  }, jsx("div", null, jsx(ContentHeader, {
    onClick: handleClick,
    link: link
  }, jsx(Link, {
    url: link,
    testId: testId
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ,
    className: blockCardForbiddenViewLinkClassName
  })), jsx(Byline, null, jsx(UnresolvedText, {
    icon: jsx(LockIcon, {
      label: "forbidden-lock-icon",
      size: "small",
      primaryColor: `var(--ds-icon-danger, ${R300})`,
      testId: `${testId}-lock-icon`
    }),
    text: jsx(FormattedMessage, _extends({}, messages[descriptiveMessageKey], {
      values: {
        product: context.text,
        context: context.text,
        hostname
      }
    }))
  }))), jsx(ContentFooter, null, jsx(Provider, {
    name: context.text,
    icon: context.icon
  }), !(actionOptions !== null && actionOptions !== void 0 && actionOptions.hide) && jsx(ActionList, {
    items: items
  }))));
};